var map = {
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"authentication-authentication-module~catalogos-catalogos-module~simtools-simtools-module",
		"common",
		"authentication-authentication-module"
	],
	"./catalogos/catalogos.module": [
		"./src/app/catalogos/catalogos.module.ts",
		"authentication-authentication-module~catalogos-catalogos-module~simtools-simtools-module",
		"catalogos-catalogos-module~documentos-documentos-module",
		"common",
		"catalogos-catalogos-module"
	],
	"./dashboards/dashboards.module": [
		"./src/app/dashboards/dashboards.module.ts",
		"common",
		"dashboards-dashboards-module"
	],
	"./documentos/documentos.module": [
		"./src/app/documentos/documentos.module.ts",
		"documentos-documentos-module~material-component-material-module~simtools-simtools-module",
		"catalogos-catalogos-module~documentos-documentos-module",
		"common",
		"documentos-documentos-module"
	],
	"./flujos/flujos.module": [
		"./src/app/flujos/flujos.module.ts",
		"flujos-flujos-module"
	],
	"./material-component/material.module": [
		"./src/app/material-component/material.module.ts",
		"documentos-documentos-module~material-component-material-module~simtools-simtools-module",
		"common",
		"material-component-material-module"
	],
	"./simtools/simtools.module": [
		"./src/app/simtools/simtools.module.ts",
		"authentication-authentication-module~catalogos-catalogos-module~simtools-simtools-module",
		"documentos-documentos-module~material-component-material-module~simtools-simtools-module",
		"common",
		"simtools-simtools-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;